// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__15NgY","savePackageButton":"ClientWallet_savePackageButton__3EkYL"};